module.exports = __webpack_public_path__ + "static/img/black.a46a275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/black.png
// module id = QmXb
// module chunks = 19